import React from 'react';
import { ObjectId } from 'bson';
import { BareContentTemplate } from '@go-shared/types/contentTemplate';
import { BubbleAccordion } from '@go-client/components/BubbleUI';

import { ContentBlurbs } from './Blurbs/ContentBlurbs';
import { Event } from '@go-shared/types/event';
import { Property } from '@go-shared/types/property';
import DraggableVenueRundown from '../VenueRundown/DraggableVenueRundown';
import DraggableVenueMealPeriods from '../VenueMealPeriods/DraggableVenueMealPeriods';

import './FeedEditorSidebar.scss';

import { SailingDateWidget } from '../Widgets/SailingDateWidget/SailingDateWidget';
import { EventBlurbs } from './Blurbs/EventBlurbs/EventBlurbs';
import { User } from '@go-shared/types/user';
import { DailyProgram } from '@go-shared/types/dailyProgram';
import DraggableEventRundown from '../EventRundown/DraggableEventRundown';

interface FeedEditorSidebarProps {
  variant: 'navy' | 'velvet';
  contentTemplates: BareContentTemplate[];
  events: Event[];
  dailyProgram: DailyProgram;
  user: User;
  property: Property;
  onAddNewContentClick: () => void;
  onContentDoubleClick?: (content: BareContentTemplate) => void;
}

export const FeedEditorSidebar: React.FC<FeedEditorSidebarProps> = ({
  variant,
  contentTemplates,
  user,
  events,
  property,
  onAddNewContentClick,
  onContentDoubleClick,
}) => {
  return (
    <BubbleAccordion
      className="h-full w-full flex flex-col"
      variant={variant}
      labels={['Events', 'Content', 'Widgets']}
      open={[1]}
      singleMode
    >
      <EventBlurbs variant={variant} events={events} property={property} />
      <ContentBlurbs
        property={property}
        user={user}
        variant={variant}
        contentTemplates={contentTemplates}
        onAddNewContentClick={onAddNewContentClick}
        onDoubleClick={onContentDoubleClick}
      />
      <div className="grid grid-cols-1 p-4 gap-1">
        <DraggableEventRundown
          contentTemplate={{
            _id: new ObjectId().toHexString(),
            name: 'Event Rundown',
            property: property._id,
            content: new ObjectId().toHexString(),
            params: {
              widgetType: 'event-rundown',
              startDateOffset: 0,
              endDateOffset: 0,
            },
          }}
        />

        <DraggableVenueRundown
          contentTemplate={{
            property: property._id,
            _id: new ObjectId().toHexString(),
            name: 'Venue Rundown',
            content: new ObjectId().toHexString(),
            params: {
              venueRundownConfig: [],
            },
          }}
        />
        <DraggableVenueMealPeriods
          contentTemplate={{
            property: property._id,
            _id: new ObjectId().toHexString(),
            name: 'Meal Periods Rundown',
            content: new ObjectId().toHexString(),
            params: {
              venueMealPeriodsConfig: [],
            },
          }}
        />
        <SailingDateWidget.draggable />
      </div>
    </BubbleAccordion>
  );
};
